import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    display: block;\n    background: none;\n    border: none;\n    box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback } from 'react';
import styled from 'styled-components';
var StyledForm = styled.form(_templateObject());
export function Form(props) {
  var onSubmit = props.onSubmit,
      children = props.children,
      name = props.name,
      other = __rest(props, ["onSubmit", "children", "name"]);

  var handleSubmit = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (onSubmit) {
      onSubmit({
        name: name
      });
    }
  }, [name, onSubmit]);
  var handleKeyDown = useCallback(function (_ref) {
    var code = _ref.nativeEvent.code,
        metaKey = _ref.metaKey,
        ctrlKey = _ref.ctrlKey;
    var isModifierPressed = navigator.platform.toLowerCase().includes('mac') ? metaKey : ctrlKey;

    if (code === 'Enter' && isModifierPressed && onSubmit) {
      onSubmit({
        name: name
      });
    }
  }, [name, onSubmit]);
  return React.createElement(StyledForm, Object.assign({}, other, {
    onSubmit: handleSubmit,
    onKeyDown: handleKeyDown
  }), children);
}